const initialCategory = {
    categories : [],
    categorymessages:{}
};

const CategoryReducer = (category = initialCategory, action) => {
    switch (action.type) {
        case 'GET_CATEGORIES':
          return {
            ...category, categories: action.payload.data
        };
        case 'ADD_CATEGORY':
          return {
            ...category, categorymessages: action.payload.data
        };
        case 'UPDATE_CATEGORY':
          return {
            ...category, categorymessages: action.payload.data
        };
        
          default:
            return category;
    }
}
export default CategoryReducer;